/**
 * ลิงก์ไปหน้าสินค้า — หน้าเต็มตั้งแต่ 28 ต.ค. 2026 (เดิมเป็นโมดัลในหน้ารายการ)
 *   /master-data/products          รายการ
 *   /master-data/products/:id      รายละเอียด (products.view)
 *   /master-data/products/:id/edit แก้ไข (products.view + products.edit)
 *   /master-data/products/new      เพิ่มใหม่ (products.create)
 */
export const PRODUCTS_PATH = '/master-data/products';
export const PRODUCT_NEW_URL = `${PRODUCTS_PATH}/new`;

/** หน้ารายละเอียดสินค้า — id ไม่ถูกต้อง = หน้ารายการ */
export function productDetailUrl(productId: number | string | null | undefined): string {
  const n = Number(productId);
  return Number.isInteger(n) && n > 0 ? `${PRODUCTS_PATH}/${n}` : PRODUCTS_PATH;
}

export function productEditUrl(productId: number | string | null | undefined): string {
  const url = productDetailUrl(productId);
  return url === PRODUCTS_PATH ? url : `${url}/edit`;
}
